import * as React from "react";
import QuoteSection from "./QuoteSection";

const quotes = [
  {
    image: "https://cdn.builder.io/api/v1/image/assets/TEMP/78fd8679919ae1fc18b54a7410ba2cfe3ff16c7b9b4e7cf86d0419915f3b4ad5?placeholderIfAbsent=true&apiKey=b9b4bb420cb64e36b6b71e99a06536e1",
    hoverImage: "https://cdn.builder.io/api/v1/image/assets/TEMP/0be869f7bd94f949307ccb83146de6c86c8eeb69b6d18cd14ee5ef8f30a1a339?placeholderIfAbsent=true&apiKey=b9b4bb420cb64e36b6b71e99a06536e1",
    imageAlt: "Traditional Morin Khuur instrument",
    quote: "The morin khuur is the only instrument in the world that plays horsehair with horsehair—letting nature resonate through itself.",
    author: "Morin khuur musician Shine Tsog-Geni",
    imageLeft: true
  },
  {
    image: "https://cdn.builder.io/api/v1/image/assets/TEMP/b5e53fa5989677eacdaa173ca7df9e602c63900e521a908ebcf0f54e15b9c4ce?placeholderIfAbsent=true&apiKey=b9b4bb420cb64e36b6b71e99a06536e1",
    hoverImage: "https://cdn.builder.io/api/v1/image/assets/TEMP/837773d4597fe636444f256230d21817a860c6633e43b9c0c99bfd43a9e19ac2?placeholderIfAbsent=true&apiKey=b9b4bb420cb64e36b6b71e99a06536e1",
    imageAlt: "Yak in its natural habitat",
    quote: "I often think—if our ancestors had not domesticated and tamed the yak, it might today be a protected wild animal.To use products that come from such a remarkable creature carries a truly special feeling.",
    author: "Writer and poet G. Ayurzana",
    imageLeft: false
  },
  {
    image: "https://cdn.builder.io/api/v1/image/assets/TEMP/3034dbd4bdc754a8d2e0df83aa018c00acb402e31868a739ef1eacf3ea9758d7?placeholderIfAbsent=true&apiKey=b9b4bb420cb64e36b6b71e99a06536e1",
    hoverImage: "https://cdn.builder.io/api/v1/image/assets/TEMP/799833b847fee60755b5028061a1086d4572e0a3fb94c6e13f96a6233327afb2?placeholderIfAbsent=true&apiKey=b9b4bb420cb64e36b6b71e99a06536e1",
    imageAlt: "Natural landscape view",
    quote: "Nature is the victim of humanity’s endless consumption. Imagine for a moment—what if we ourselves became victims of others’ consumption?This imbalance is something only we can restrain.Because every one of us is a part of nature itself.",
    author: "Recipient of the Union of Mongolian Artists Award N. Sukhburen",
    imageLeft: true
  }
];

function JournalLayout() {
  return (
    <main className="flex flex-col items-center mt-20 sm:mb-[100px]">
      <h1 className="gap-2.5 self-stretch px-2.5 pt-16 pb-16 text-8xl text-center text-black uppercase whitespace-nowrap max-md:max-w-full max-md:text-4xl">
        journal
      </h1>
      <section className="flex relative flex-col self-stretch px-16 pt-96 pb-80 w-full text-4xl text-center text-white min-h-[867px] max-md:px-5 max-md:pt-24 max-md:pb-28 max-md:max-w-full">
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/ef0b010bd1d333a0b342fea94d859fe23b13758b5b50e646e7c098bb20a2a795?placeholderIfAbsent=true&apiKey=b9b4bb420cb64e36b6b71e99a06536e1"
          alt="Nature inspired creation banner"
          className="object-cover absolute inset-0 size-full"
        />
        <h2 className="absolute text-4xl sm:text-2xl font-bold top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white max-md:text-xl">
          GIFTED BY NATURE, CREATED BY BODIOS
        </h2>
      </section>
      {quotes.map((quote, index) => (
        <QuoteSection key={index} {...quote} />
      ))}
    </main>
  );
}

export default JournalLayout;
